<p class="mb-0">
  <ng-container
    *ngIf="
      notExecuted ||
        baseProject.status === 'Uitgesteld' ||
        componentsExecuted === false;
      else executionInfo
    "
  >
    <b>{{
      baseProject.status === 'Uitgesteld' ? 'Uitgesteld' : 'Niet uitgevoerd'
    }}</b>
  </ng-container>
  <ng-template #executionInfo>
    {{ executed ? 'Uitgevoerd op' : 'Uitvoering gepland op' }}:
    <b>{{ tourDateDisplay | or }}</b>
  </ng-template>
</p>
<ng-container *ngIf="!baseProject.fromOldSystem">
  <ng-container *ngIf="baseProject.status !== 'Uitgesteld'; else delayedInfo">
    <ng-container
      *ngIf="componentsExecuted !== false; else notExecutedHistoryItemDisplay"
    >
      <p *ngIf="!notExecuted" class="mb-0">
        Installateur: <b>{{ tourInstallerDisplay | or }}</b>
      </p>
      <p *ngIf="executed || notExecuted" class="mt-3">
        {{ installerFeedback | or: 'Geen feedback van de installateur' }}
      </p>
    </ng-container>
    <ng-template #notExecutedHistoryItemDisplay>
      <div *ngIf="notExecutedHistoryItem != null" class="d-flex upper-space">
        <div class="author-display">
          <div *ngIf="notExecutedHistoryItem.author != null">
            {{
              notExecutedHistoryItem.author.firstName
                | personName: notExecutedHistoryItem.author.lastName
            }}
          </div>
          <div *ngIf="notExecutedHistoryItem.createdTimestamp != null">
            {{
              notExecutedHistoryItem.createdTimestamp
                | formatDate: '':'dd/MM/yyyy'
            }}
          </div>
        </div>
        <div class="content-display">
          <p>{{ notExecutedHistoryItem.onlineInfo }}</p>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-template #delayedInfo>
    <p class="mb-0">{{ baseProject.delayedReason }}</p>
  </ng-template>
</ng-container>
